import { onScroll } from '../../../utils/on-scroll';

const CLASSNAMES = {
    STICKY: 'sticky',
    STICKY_TOP: 'sticky__top',
    STICKY_BOTTOM: 'sticky__bottom',
};

export const STICK_POSITION_BOTTOM = 'bottom';
export const STICK_POSITION_TOP = 'top';

export default class Sticky {
    constructor(element, options = { stickTo: 'top', stickyCondition: () => false }) {
        if (!element) {
            throw new Error('Provide an element for sticky element');
        }
        this.options = options;
        this.element = element;
        // eslint-disable-next-line
        let { parentElement } = element;
        parentElement.style.height = `${element.getBoundingClientRect().height}px`;
    }

    init = () => {
        this.findCoordinates();
        this.scrollUnsubscribe = onScroll(this.findCoordinates);
        window.addEventListener('resize', this.findCoordinates);
    };

    findCoordinates = () => {
        const windowParams = {
            offsetTop: window.pageYOffset,
            offsetBottom: window.pageYOffset + document.documentElement.clientHeight,
            innerHeight: window.innerHeight,
            innerWidth: window.innerWidth,
        };

        const { top, bottom } = this.element.parentElement.getBoundingClientRect();

        if (
            this.options.stickyCondition({
                isSticked: this.isSticked(this.element),
                top,
                bottom,
                ...windowParams,
            })
        ) {
            this.showSticky(this.element);
        } else {
            this.hideSticky(this.element);
        }
    };

    isSticked(element = this.element) {
        if (this.options.stickTo === STICK_POSITION_BOTTOM) {
            return this.sticked;
        }

        return element.classList.contains(CLASSNAMES.STICKY);
    }

    showSticky = element =>
        this.options.stickTo === STICK_POSITION_BOTTOM
            ? this.showStickyBottom(element)
            : this.showStickyTop(element);

    showStickyTop = element => {
        if (this.options.onStickStart && !this.isSticked(element)) {
            this.options.onStickStart(element);
        }
        element.classList.add(CLASSNAMES.STICKY);
        if (this.options.stickyAdditionalClass) {
            element.classList.add(this.options.stickyAdditionalClass);
        }
        element.classList.add(
            this.options.stickTo === 'bottom' ? CLASSNAMES.STICKY_BOTTOM : CLASSNAMES.STICKY_TOP
        );
    };

    showStickyBottom = element => {
        if (this.clonedEl) {
            window.APC_USC.show(this.clonedEl);
            this.sticked = true;
            return;
        }

        this.clonedEl = element.cloneNode(true);

        this.clonedEl.addEventListener('click', () => {
            const selClickable = 'input, button, a';
            const elClickable = element.matches(selClickable)
                ? element
                : element.querySelector(selClickable);

            if (elClickable) {
                elClickable.click();
            } else {
                // eslint-disable-next-line no-console
                console.error('clickable element is not found in the clone');
            }
        });
        window.APC_USC.add(this.clonedEl);

        this.sticked = true;
        if (this.options.onStickStart && !this.isSticked(element)) {
            this.options.onStickStart(element);
        }
        this.clonedEl.classList.add(CLASSNAMES.STICKY);
        if (this.options.stickyAdditionalClass) {
            this.clonedEl.classList.add(this.options.stickyAdditionalClass);
        }
        this.clonedEl.classList.add(
            this.options.stickTo === 'bottom' ? CLASSNAMES.STICKY_BOTTOM : CLASSNAMES.STICKY_TOP
        );
    };

    hideSticky = element => {
        if (!this.isSticked(element)) {
            return;
        }

        if (this.options.onStickRelease && this.isSticked(element)) {
            this.options.onStickRelease(element);
        }

        if (this.options.stickTo === STICK_POSITION_BOTTOM) {
            window.APC_USC.hide(this.clonedEl);
            this.sticked = false;
        } else {
            element.classList.remove(CLASSNAMES.STICKY);
            element.classList.remove(CLASSNAMES.STICKY_TOP);
            element.classList.remove(CLASSNAMES.STICKY_BOTTOM);
            element.classList.remove(this.options.stickyAdditionalClass);
        }
    };

    destroy = () => {
        if (this.options.stickTo === STICK_POSITION_BOTTOM) {
            if (this.clonedEl) {
                window.APC_USC.remove(this.clonedEl);
            }
        } else {
            this.hideSticky(this.element);
        }
        if (typeof this.scrollUnsubscribe === 'function') {
            this.scrollUnsubscribe();
        }
    };
}
